module.exports = __webpack_public_path__ + "static/media/shipping_new@2x.e8fe44f4.jpg";